"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionsApi = exports.ExpansionsApiFactory = exports.ExpansionsApiFp = exports.ExpansionsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ExpansionsApi - axios parameter creator
 * @export
 */
const ExpansionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get expansions list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpansionsList: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/expansion/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get purchased expansion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedExpansion: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/expansion/purchased`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove expansion
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExpansion: (subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            (0, common_1.assertParamExists)('removeExpansion', 'subscriptionId', subscriptionId);
            const localVarPath = `/expansion/{subscriptionId}/remove`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ExpansionsApiAxiosParamCreator = ExpansionsApiAxiosParamCreator;
/**
 * ExpansionsApi - functional programming interface
 * @export
 */
const ExpansionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ExpansionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get expansions list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpansionsList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExpansionsList(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get purchased expansion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedExpansion(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPurchasedExpansion(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Remove expansion
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExpansion(subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeExpansion(subscriptionId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ExpansionsApiFp = ExpansionsApiFp;
/**
 * ExpansionsApi - factory interface
 * @export
 */
const ExpansionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ExpansionsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get expansions list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpansionsList(options) {
            return localVarFp.getExpansionsList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get purchased expansion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedExpansion(options) {
            return localVarFp.getPurchasedExpansion(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove expansion
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExpansion(subscriptionId, options) {
            return localVarFp.removeExpansion(subscriptionId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ExpansionsApiFactory = ExpansionsApiFactory;
/**
 * ExpansionsApi - object-oriented interface
 * @export
 * @class ExpansionsApi
 * @extends {BaseAPI}
 */
class ExpansionsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get expansions list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpansionsApi
     */
    getExpansionsList(options) {
        return (0, exports.ExpansionsApiFp)(this.configuration).getExpansionsList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get purchased expansion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpansionsApi
     */
    getPurchasedExpansion(options) {
        return (0, exports.ExpansionsApiFp)(this.configuration).getPurchasedExpansion(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove expansion
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpansionsApi
     */
    removeExpansion(subscriptionId, options) {
        return (0, exports.ExpansionsApiFp)(this.configuration).removeExpansion(subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ExpansionsApi = ExpansionsApi;
